var _rect, _path, _g, _path2, _g2, _path3, _g3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcKoleksiUmum(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 105,
    viewBox: "0 0 81 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1074_743",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 81,
    height: 105
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 81,
    height: 105,
    rx: 15,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1074_743)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1074_743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 81,
    height: 105
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81 0H0V105H81V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1074_743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.966 -11.3737H-27.3486V113.22H40.997C42.548 113.22 44.0989 113.013 45.5982 112.548C51.3884 110.79 62.9689 105.672 71.4992 94.5052C76.2555 88.3013 78.6853 81.6839 79.771 75.5318C81.7356 64.4682 79.5125 53.0428 73.9808 43.2718C65.8124 28.9512 57.6957 14.6307 49.5273 0.310182C49.2171 -0.258503 48.8552 -0.827189 48.4416 -1.39587C47.3042 -2.99853 45.6499 -4.91138 43.4268 -6.72084C41.1521 -8.63369 38.8774 -9.87446 37.0162 -10.7533C36.0856 -11.1669 35 -11.3737 33.966 -11.3737Z",
    fill: "#B4E5F9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1074_743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 81,
    height: 105
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81 0H0V105H81V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1074_743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.0355 -3.41211H-20.4209V105.31H39.2394C40.5835 105.31 41.9277 105.103 43.2202 104.742C48.2866 103.191 58.3679 98.7445 65.8125 89.0251C69.9484 83.5968 72.068 77.8582 73.0503 72.4815C74.7564 62.8139 72.8435 52.8877 67.9838 44.3575C60.9011 31.8464 53.7667 19.387 46.684 6.87593C46.3738 6.35894 46.0636 5.84195 45.7534 5.37667C44.7711 3.9808 43.3236 2.32644 41.4107 0.723784C39.3945 -0.930573 37.4299 -2.06794 35.8273 -2.79172C34.845 -3.25701 33.9661 -3.41211 33.0355 -3.41211Z",
    fill: "url(#paint0_linear_1074_743)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1074_743",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 81,
    height: 105
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81 0H0V105H81V0Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1074_743)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.8926 34.3796C43.7375 33.4491 44.1511 32.4668 44.9266 31.8981C45.547 31.4845 46.1157 31.3811 46.4776 31.3294C46.581 31.3294 46.6327 31.3294 46.736 31.3294H52.2678C52.6297 31.3294 53.0433 31.3811 53.3535 31.5879C53.5086 31.6913 53.7154 31.7947 53.8705 31.8981C53.9222 31.8981 53.9222 31.9498 53.9739 31.9498C54.7493 32.5185 55.1112 33.4491 54.9561 34.3279C54.8527 35.0517 54.5425 35.9823 53.8705 36.9129C52.578 38.6189 50.7168 39.0325 50.0965 39.1359C49.9931 39.1359 49.8897 39.1359 49.7863 39.1359C49.1142 39.1359 46.5292 39.0325 44.8749 36.9129C44.3062 36.034 43.996 35.1034 43.8926 34.3796Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.01371 22.8508C7.85862 21.9202 8.27221 20.938 9.04769 20.3693C9.66807 19.9557 10.2368 19.8523 10.5986 19.8006C10.702 19.8006 10.7537 19.8006 10.8571 19.8006H16.3889C16.7508 19.8006 17.1644 19.8523 17.4746 20.0591C17.6297 20.1625 17.8365 20.2659 17.9916 20.3693C18.0433 20.3693 18.0433 20.421 18.095 20.421C18.8704 20.9897 19.2323 21.9202 19.0772 22.7991C18.9738 23.5229 18.6636 24.4535 17.9916 25.3841C16.6991 27.0901 14.8379 27.5037 14.2176 27.6071C14.1142 27.6071 14.0108 27.6071 13.9074 27.6071C13.2353 27.6071 10.6503 27.5037 8.99599 25.3841C8.37561 24.5569 8.11711 23.6263 8.01371 22.8508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.30706 45.7016C7.23763 45.5465 8.21991 45.9601 8.7886 46.7356C9.20218 47.356 9.30558 47.9247 9.35728 48.2866C9.35728 48.39 9.35728 48.4417 9.35728 48.5451V54.0768C9.35728 54.4387 9.30558 54.8523 9.09879 55.1625C8.99539 55.3176 8.89199 55.5244 8.7886 55.6795C8.7886 55.7312 8.7369 55.7312 8.7369 55.7829C8.16821 56.5584 7.23763 56.9203 6.35876 56.7652C5.63497 56.6618 4.7044 56.3516 3.77382 55.6795C2.06777 54.387 1.65418 52.5259 1.55078 51.9055C1.55078 51.8021 1.55078 51.6987 1.55078 51.5953C1.55078 50.9232 1.65418 48.3383 3.77382 46.6839C4.601 46.0635 5.58328 45.805 6.30706 45.7016Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.923 76.5657C51.6985 77.1344 52.1121 78.1167 51.9053 79.0473C51.7502 79.771 51.3883 80.2363 51.1815 80.5465C51.1298 80.5982 51.0781 80.6499 51.0264 80.7016L47.0973 84.6307C46.8388 84.8892 46.5286 85.096 46.1667 85.2511C46.0116 85.3028 45.8048 85.3545 45.5464 85.4062C45.4947 85.4062 45.4947 85.4062 45.443 85.4062C44.5124 85.5613 43.5818 85.1477 43.0648 84.3722C42.5995 83.7518 42.1342 82.9247 41.9791 81.7873C41.669 79.6676 42.7029 78.065 43.0648 77.548C43.1165 77.4446 43.1682 77.3929 43.2716 77.3412C43.7369 76.8759 45.6497 75.1182 48.3381 75.4801C49.4238 75.6351 50.3026 76.1004 50.923 76.5657Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8625 90.0074C34.638 90.5761 35.0515 91.5583 34.8447 92.4889C34.6897 93.2127 34.3278 93.678 34.121 93.9882C34.0693 94.0399 34.0176 94.0916 33.9659 94.1433L30.0368 98.0724C29.7783 98.3309 29.4681 98.5377 29.1062 98.6927C28.9511 98.7444 28.7443 98.7961 28.4858 98.8478C28.4341 98.8478 28.4341 98.8478 28.3824 98.8478C27.4518 99.0029 26.5213 98.5894 26.0043 97.8139C25.539 97.1935 25.0737 96.3663 24.9186 95.2289C24.6084 93.1093 25.6424 91.5066 26.0043 90.9896C26.056 90.8863 26.1077 90.8346 26.2111 90.7829C26.6764 90.3176 28.5892 88.5598 31.2775 88.9217C32.3632 89.0768 33.2421 89.5421 33.8625 90.0074Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1244 17.0606C29.8375 17.0606 31.2263 15.6718 31.2263 13.9586C31.2263 12.2455 29.8375 10.8567 28.1244 10.8567C26.4112 10.8567 25.0225 12.2455 25.0225 13.9586C25.0225 15.6718 26.4112 17.0606 28.1244 17.0606Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3363 83.8035C18.0494 83.8035 19.4382 82.4148 19.4382 80.7016C19.4382 78.9885 18.0494 77.5997 16.3363 77.5997C14.6232 77.5997 13.2344 78.9885 13.2344 80.7016C13.2344 82.4148 14.6232 83.8035 16.3363 83.8035Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5716 65.2954C66.2848 65.2954 67.6736 63.9066 67.6736 62.1935C67.6736 60.4804 66.2848 59.0916 64.5716 59.0916C62.8585 59.0916 61.4697 60.4804 61.4697 62.1935C61.4697 63.9066 62.8585 65.2954 64.5716 65.2954Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4235 26.0044C50.5085 26.0044 51.3881 25.1249 51.3881 24.0399C51.3881 22.9549 50.5085 22.0753 49.4235 22.0753C48.3385 22.0753 47.459 22.9549 47.459 24.0399C47.459 25.1249 48.3385 26.0044 49.4235 26.0044Z",
    fill: "white"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9473 71.2924H53.0433V49.7341C53.0433 48.2348 51.8542 47.0458 50.3549 47.0458H40.6356C39.1363 47.0458 37.9473 48.2348 37.9473 49.7341V71.2924ZM41.9281 52.2673C41.9281 51.5953 42.4967 51.0266 43.1688 51.0266H47.8734C48.5455 51.0266 49.1142 51.5953 49.1142 52.2673V67.3634H41.9281V52.2673Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5215 71.2924H35.9823V48.8035C35.9823 46.7356 37.6884 45.0295 39.7563 45.0295H41.6175V41.4623C41.6175 39.9631 40.4284 38.774 38.9292 38.774H29.2098C27.7106 38.774 26.5215 39.9631 26.5215 41.4623V71.2924Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5049 40.48C24.5049 38.3087 26.2626 36.5509 28.434 36.5509H30.1917V32.9837C30.1917 31.4845 29.0026 30.2954 27.5034 30.2954H17.784C16.2848 30.2954 15.0957 31.4845 15.0957 32.9837V71.2408H24.5566V40.48H24.5049Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1668 73.1536C10.1328 73.1536 9.30566 73.9808 9.30566 75.0148V76.9276H58.7813V75.0148C58.7813 73.9808 57.9541 73.1536 56.9201 73.1536H11.1668Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1074_743",
    x1: -35.7589,
    y1: 80.4352,
    x2: 56.8466,
    y2: 23.4313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26A0DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB4EA"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcKoleksiUmum);
export default __webpack_public_path__ + "static/media/ic-koleksi-umum.ca6b586b97df03363da4cb3ed176b624.svg";
export { ForwardRef as ReactComponent };